<template>
  <div>
    <modal @close="onAccept">
      <h3 slot="header">{{ title }}</h3>
      <div slot="body">
        <slot name="body">
        </slot>
      </div>
      <div slot="footer">
        <btn-pill btn-size="s" @click="onAccept">{{ acceptButtonText() }}</btn-pill>
      </div>
    </modal>
  </div>
</template>

<script>
import BtnPill from '@/components/shared/buttons/BtnPill';
import Modal from '@/components/shared/dialogs/Modal';

export default {
  components: {
    BtnPill,
    Modal
  },
  props: {
    title: {
      type: String
    },
    acceptButton: {
      type: String
    }
  },
  created () {
    document.body.addEventListener('keyup', this.onKeyUp);
  },
  destroyed () {
    document.body.removeEventListener('keyup', this.onKeyUp);
  },
  methods: {
    onAccept (event) {
      this.$emit('accept', event);
    },
    acceptButtonText () {
      if (this.acceptButton === undefined) {
        return this.$t('commons.ok');
      }
      return this.acceptButton;
    },
    onKeyUp (event) {
      switch (event.keyCode) {
        case 13:
        case 27:
          this.$emit('accept', event);
          break;
      }
    }
  }
};

</script>



// WEBPACK FOOTER //
// src/components/shared/dialogs/AcceptModal.vue